import { OverflowMenuItem, OverflowMenuItemProps } from "@carbon/react";
import { FC, ReactNode, forwardRef } from "react";

import { AppUser } from "src/authentication/appUser.ts";
import { Permission } from "src/authentication/PermissionsProvider";
import { usePermissions } from "src/authentication/usePermissions.ts";

type AuthorizedItemProps = {
  children: ReactNode;
  requiredPermissions: Permission[];
};
export const AuthorizedItem: FC<AuthorizedItemProps> = ({ children, requiredPermissions }) => {
  const { hasPermissions } = usePermissions();
  const isAuthorized = hasPermissions(requiredPermissions);

  if (isAuthorized || !AppUser.isAuthenticationEnabled) {
    return <>{children}</>;
  }

  return <></>;
};

type AuthorizedMenuProps = {
  children: ReactNode;
  menuItemsPermissions: Permission[];
};

export const AuthorizedMenu: FC<AuthorizedMenuProps> = ({ children, menuItemsPermissions }) => {
  const { hasPartialPermissions } = usePermissions();
  const isAuthorized = hasPartialPermissions(menuItemsPermissions);

  if (isAuthorized || !AppUser.isAuthenticationEnabled) {
    return <>{children}</>;
  }

  return <></>;
};

type AuthorizedOverflowMenuItemProps = {
  requiredPermissions: Permission[];
} & OverflowMenuItemProps;

export const AuthorizedOverflowMenuItem = forwardRef<HTMLElement, AuthorizedOverflowMenuItemProps>(
  function AuthorizedOverflowMenuItem(
    {
      requiredPermissions,
      closeMenu,
      itemText,
      onClick,
      disabled,
      hasDivider,
      requireTitle,
      title,
      isDelete,
    },
    ref
  ) {
    const { hasPermissions } = usePermissions();
    const isAuthorized = hasPermissions(requiredPermissions);

    if (!isAuthorized && AppUser.isAuthenticationEnabled) {
      return null;
    }

    return (
      <OverflowMenuItem
        isDelete={isDelete}
        ref={ref}
        closeMenu={closeMenu}
        itemText={itemText}
        onClick={onClick}
        disabled={disabled}
        hasDivider={hasDivider}
        requireTitle={requireTitle}
        title={title}
      />
    );
  }
);
